// Sitelink landing pages: same home page, with route-specific SEO tags,
// hero message-match copy and (optionally) auto-scroll to a section.
const SITE = 'https://findmeagent.com.au';

export const LANDING_PAGES = {
  '/how-it-works': {
    title: 'How It Works | FindMeAgent - Free Agent Matching in 3 Steps',
    description: 'Tell us about your property, we shortlist 2 to 3 pre-vetted local agents, you compare and choose. Free, under a minute, no obligation.',
    h1: 'How FindMeAgent Works',
    subtitle: 'Three Simple Steps, Under a Minute',
    lead: 'Enter your details, receive a free shortlist of pre-vetted local agents, then compare and choose with confidence. No cost, no obligation.',
    sectionId: 'how-it-works',
  },
  '/why-us': {
    title: 'Why Choose FindMeAgent | Pre-Vetted, Licence-Checked Agents',
    description: 'Every agent is licence-checked and screened for recent local sales and verified reviews. 100% free for homeowners, no obligation.',
    h1: 'Why Choose FindMeAgent',
    subtitle: 'Pre-Vetted Local Experts, Zero Cost',
    lead: 'We check every agent\'s licence, recent sales record and client reviews before introducing them. You pay nothing and are never locked in.',
    sectionId: 'why-use',
  },
  '/sell-your-property': {
    title: 'Sell Your Property | Compare Top Local Agents Free - FindMeAgent',
    description: 'Selling your home? Compare appraisals, commission rates and marketing plans from pre-vetted agents with recent sales in your suburb. Free service.',
    h1: 'Selling Your Property?',
    subtitle: 'Compare Top Local Agents, Free',
    lead: 'Get appraisals, commission rates and marketing plans from 2 to 3 pre-vetted agents with proven recent sales in your suburb. Free and no obligation.',
    sectionId: null,
  },
  '/free-property-appraisal': {
    title: 'Free Property Appraisal | How Much Is My House Worth? - FindMeAgent',
    description: 'Find out what your home is worth. Get a free, no-obligation property appraisal from 2 to 3 pre-vetted local agents with recent sales in your suburb.',
    h1: 'Get a Free Property Appraisal',
    subtitle: 'Find Out What Your Home Is Really Worth',
    lead: 'Enter your address and we\'ll arrange free, no-obligation appraisals from 2 to 3 pre-vetted agents who have recently sold homes like yours nearby. Compare their valuations, fees and plans before you decide.',
    sectionId: null,
  },
  '/compare-agents': {
    title: 'Compare Real Estate Agents | Free Local Shortlist - FindMeAgent',
    description: 'Compare pre-vetted real estate agents in your suburb on experience, fees and reviews. Receive a free shortlist of 2 to 3 agents, usually within a day.',
    h1: 'Compare Local Real Estate Agents',
    subtitle: 'Fees, Sales History and Reviews Side by Side',
    lead: 'Receive a free shortlist of 2 to 3 pre-vetted agents who know your suburb, then compare fees, sales history and reviews before you decide.',
    sectionId: null,
  },
  '/faq': {
    title: 'FAQs | Is FindMeAgent Really Free? How Fast? - FindMeAgent',
    description: 'Answers to common questions: Is it free? How quickly will I hear back? Am I obligated to choose an agent? How are agents vetted?',
    h1: 'Frequently Asked Questions',
    subtitle: 'Everything You Need to Know',
    lead: 'Straight answers on cost, timing, obligation and how we vet agents, so you can start with confidence.',
    sectionId: 'faq',
  },
  '/join-as-agent': {
    title: 'Real Estate Agents: Join FindMeAgent | Quality Local Leads',
    description: 'Licensed Australian real estate agents: apply to join the FindMeAgent network and receive motivated, qualified seller and buyer leads in your area.',
    h1: 'Agents: Join the FindMeAgent Network',
    subtitle: 'Quality Local Leads for Licensed Agents',
    lead: 'Grow your business with motivated, pre-qualified sellers and buyers in your service area. Apply in minutes.',
    sectionId: 'agent-join',
  },
};

export const LANDING_PATHS = Object.keys(LANDING_PAGES);

export const canonicalFor = (path) => `${SITE}${path === '/' ? '/' : path}`;
